import { createFileRoute, redirect } from '@tanstack/react-router';
import { Pane } from '@sheridan-prize/ui';
import { SpSidebar } from '../components/Sidebar';
import { getAuthStore } from '../main';
import { Vote } from '../components/Vote';
import { AccountHeader } from '../components/AccountHeader';

export const Route = createFileRoute('/vote-artwork')({
  beforeLoad: async () => {
    const useAuthStore = getAuthStore();
    await useAuthStore.fetchUser();

    const isAuthenticated = useAuthStore.getIsAuthenticated();
    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    const userRole = useAuthStore.getUser();
    if (userRole?.role !== 'artist' && userRole?.role !== 'viewer') {
      throw redirect({ to: '/' });
    }
  },
  component: VoteArtwork,
});

function VoteArtwork() {
  return (
    <>
      <AccountHeader />
      <div className="app">
        <SpSidebar />
        <Pane classes={'sp-main'} tag="main">
          <h1 style={{ marginBlockEnd: 'var(--spacing-static-6)' }}>
            Vote on Artwork and Help Award More Prizes!
          </h1>
          <Vote />
        </Pane>
      </div>
    </>
  );
}
